
export const formatDetails = (richTextDetails, location) => {
  let details = null

  if (richTextDetails) {
    const data = {
      content: richTextDetails,
      colorScheme: "transparentDarkText",
    }
    details = <></>
  }

  return details
}

const parseCookieName = (cookieName, updatedAt) => {
  return `pb-${cookieName}-${updatedAt ? Date.parse(updatedAt) : 0}`
}

export const setBannerCookie = (cookiesApi, cookieName, updatedAt, redisplayDuration) => {
  if (typeof window === "undefined") {
    return
  }

  const savedCookieName = parseCookieName(cookieName, updatedAt)
  cookiesApi.set(savedCookieName, "true", {
    expires: redisplayDuration,
    path: "/",
    secure: window.location.protocol === "https:",
  })
}

export const checkBannerCookie = (cookiesApi, cookieName, updatedAt) => {
  if (typeof window === "undefined") {
    return
  }
  return cookiesApi.get(parseCookieName(cookieName, updatedAt))
}

export const withinDateRange = (startDate, endDate) => {
  const parsedStart = startDate ? Date.parse(startDate) : 0
  const parsedEnd = endDate ? Date.parse(endDate) : 0
  const now = Date.now()
  return now >= parsedStart && now <= parsedEnd
}

export const returnActivePromotionBanner = promotionBanner => {
  let activeBanner
  if (promotionBanner && promotionBanner?.length) {
    activeBanner = promotionBanner?.filter(banner =>
      withinDateRange(banner.startDate, banner.endDate)
    )
    activeBanner = activeBanner.sort().reverse()
  } else {
    activeBanner = null
  }
  return activeBanner
}
